'Disposition'.datatype()
'description'.field({key: true})

'Disposition'.data(
  [
    {description: "Number"},
    {description: "Text"},
    {description: "Barcode"},
    {description: "Date"},
    {description: "Image"},
  ]
)
